import _ from "lodash";
import React, { useEffect } from "react";
import { PlusCircle, Trash } from 'react-bootstrap-icons';

function ArrayFieldComponent(props) {
	const { title, items, onAddClick, readonly, formData, schema, uiSchema } = props;
	const properties = _.get(schema, 'items.properties');
	const propertyKeys = Object.keys(properties);
	const widget = _.get(uiSchema, 'ui:widget', "");

	useEffect(() => {
		setTimeout(() => {
			if (_.isEmpty(formData)) {
				onAddClick();
			}
		}, 100);
	}, [formData])

	if (widget === 'hidden') {
		return null;
	}

	function renderHeader() {
		let columns = [];

		propertyKeys.forEach((k, i) => {
			let title = _.trim(properties[k].title);

			if (!_.isEmpty(title)) {
				columns.push(<th scope="col" key={i}>{title}</th>)
			}
		})

		if (!_.isEmpty(columns)) {
			return (
				<thead>
					<tr>
						{columns}
					</tr>
				</thead>
			)
		}
	}

	function renderStaticTable() {
		return (
			<div className="table-responsive">
				<table className="table ar-table">
					{renderHeader()}
					<tbody>
						{formData.map((v, i) => (
							<tr key={i}>
								{propertyKeys.map((k, j) => {
									let type = properties[k].type;

									if(type === 'boolean') {
										return (
											<td key={j}>{(formData[i][k] === true) ? 'Yes' : 'No'}</td>
										)
									} else {
										return (
											<td key={j}>{formData[i][k]}</td>
										)	
									}									
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		)
	}

	return (
		<React.Fragment>
			<label className="form-label">{title}</label>

			{readonly && renderStaticTable()}

			{!readonly &&
				<React.Fragment>
					{
						items.map((item, i) => (
							<React.Fragment key={item.key}>
								<div className={`py-2 px-3 px-md-3 pb-md-0 ${(i % 2 === 0) ? 'bg-light' : 'bg-white'} clearfix border-bottom prnf-addrow`}>
									{item.children}
									<button type="button" className="btn btn-link float-right del-btn"
										onClick={item.onDropIndexClick(i)}><Trash size={16} />
									</button>
								</div>
							</React.Fragment>
						))
					}
					<button className="btn btn-primary btn-table-add-row" onClick={onAddClick}> Add New <i><PlusCircle size={17} /> </i></button>
				</React.Fragment>
			}
		</React.Fragment >
	)
}

export default ArrayFieldComponent;